import {
  Button,
  Grid,
  IconButton,
  Icons,
  Menu,
  Popover,
  Text,
  useToggle,
} from "@pushpress/shared-components";
import { useContext, useRef, useState } from "react";
import { AppContext } from "../../../context/app";
import {
  formatMembership,
  formatPlanType,
  formatPriceDescription,
} from "../Plans.utils";
import { useFeatureFlag } from "../../../context/features";
import { PLAN_CREATE_FEATURE_FLAG } from "../../../context/features/features.utils";
import { usePlans } from "../PlansProvider/PlansProvider";
import styles from "./PlanList.module.scss";
import { GetPlansResult } from "../../../apis/subscriptionApi";

function PlanRow({
  plan,
  refetchPlans,
}: {
  plan: GetPlansResult["data"][number];
  refetchPlans: VoidFunction;
}) {
  const { client } = useContext(AppContext);

  const { isFeatureEnabled } = useFeatureFlag();

  const createPlanFlag = isFeatureEnabled(PLAN_CREATE_FEATURE_FLAG);

  const { startPlanEdition, startPlanDuplication } = usePlans();

  const [menuVisible, menuActions] = useToggle(false);

  const [selectedSubscriptionPlanUuid, setSelectedSubscriptionPlanUuid] =
    useState<string>();

  const actionButtonRef = useRef<HTMLElement | null>(null);

  const handleEditPlan = (planUuid: string) => {
    if (createPlanFlag) {
      startPlanEdition({ planUuid, onSuccess: refetchPlans });
      menuActions.off();
    } else {
      window.location.href = `/plans/edit/${selectedSubscriptionPlanUuid}`;
    }
  };

  const handleDuplicatePlan = (planUuid: string) => {
    startPlanDuplication({ planUuid, onSuccess: refetchPlans });
    menuActions.off();
  };

  return (
    <>
      <li className={styles.listItem} data-cy="list-item-row">
        <Grid item xs={4} container justifyContent="center" direction="column">
          <Text variant="body-lg" color="wolf-800">
            {plan.name}
          </Text>
          <Text variant="body-lg" color="wolf-600">
            {formatMembership(plan)}
          </Text>
        </Grid>
        <Grid item xs={3} container justifyContent="center" direction="column">
          <Text variant="body-lg" color="wolf-800">
            {formatPriceDescription(plan, client.currencyIso)}
          </Text>
          <Text variant="body-lg" color="wolf-600">
            {formatPlanType(plan.type)}
          </Text>
        </Grid>
        <Grid item xs={3} container alignItems="center">
          <Button
            buttonType="text"
            text={`${plan.activeSubscriptionsCount} active`}
            href={`/members/by_plan/${plan.uuid}`}
          />
        </Grid>
        <Grid
          item
          xs={2}
          container
          alignItems="center"
          justifyContent="flex-end"
        >
          <IconButton
            icon={Icons.Kebabs}
            data-cy="list-item-action"
            aria-label="More options"
            onClick={(event) => {
              actionButtonRef.current = event.target as HTMLElement;
              menuActions.on();
              setSelectedSubscriptionPlanUuid(plan.uuid);
            }}
          />
        </Grid>
      </li>
      <Popover
        anchorEl={actionButtonRef.current!}
        visible={menuVisible}
        onClose={menuActions.off}
      >
        <Menu>
          <Menu.Item
            label="View plan info"
            action={() =>
              // this goes to a PHP page, that's why we can't use history
              (window.location.href = `/plans/view/${selectedSubscriptionPlanUuid}`)
            }
          />
          {createPlanFlag && (
            <Menu.Item
              label="Duplicate plan"
              action={() => handleDuplicatePlan(selectedSubscriptionPlanUuid)}
            />
          )}
          <Menu.Item
            label="Edit plan"
            action={() => handleEditPlan(selectedSubscriptionPlanUuid)}
          />
        </Menu>
      </Popover>
    </>
  );
}

export default PlanRow;
